var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:!_vm.$isCN() && 'wrapper-en'},[_c('div',{staticClass:"root"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),_c('div',{staticClass:"txt"},[_vm._v(_vm._s(_vm.txt))]),_c('div',{staticClass:"ph"}),_c('www-picture',{staticClass:"img",attrs:{"w":"248","h":"149","img":_vm.img}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3480df22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HistoryItemMob.vue
// module id = 2wRu
// module chunks = 5